import React from "react";
import { ToastContainer } from "react-toastify";

const ReactToastify = ({ children }) => {
  return (
    <>
      <ToastContainer theme="colored"/>
      {children}
    </>
  );
};

export default ReactToastify;
